const LayoutSelector = ({ layouts, onSelect, selectedLayoutId }) => (
  <div style={{ display: "flex", gap: 12 }}>
    {layouts.map(layout => (
      <div
        key={layout.id}
        onClick={() => onSelect(layout)}
        style={{
          width: 70,
          height: 70,
          border: layout.id === selectedLayoutId ? "3px solid #6D28D9" : "2px solid #E5E7EB",
          borderRadius: 12,
          padding: 6,
          cursor: "pointer",
          transition: "all 0.2s"
        }}
      >
        <div
          style={{
            display: "grid",
            width: "100%",
            height: "100%",
            gap: 2,
            gridTemplateColumns: layout.gridTemplateColumns,
            gridTemplateRows: layout.gridTemplateRows,
            gridTemplateAreas: layout.areas.map(r => `"${r}"`).join(" ")
          }}
        >
          {["a", "b", "c", "d"].map(area =>
            layout.areas.join("").includes(area) ? (
              <div
                key={area}
                style={{
                  gridArea: area,
                  border: "2px solid #6D28D9",
                  borderRadius: 4
                }}
              />
            ) : null
          )}
        </div>
      </div>
    ))}
  </div>
);

export default LayoutSelector;
